import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { UploadXHRArgs, UploadFile, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import { timeout } from 'rxjs/operators';
import { URLS } from '../../constant/interface';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-image-upload',
  templateUrl: './icc-image-upload.component.html',
  styleUrls: ['./icc-image-upload.component.less'],
})
export class IccImageUploadComponent implements OnInit {
  /**
   * 是否只读
   */
  @Input() editable = true;
  /**
   * 上传路径
   */
  @Input() uploadImage = URLS.uploadImage.url || '';
  /**
   * 图片张数
   */
  @Input() maxCount = 9;
  /**
   * 图片总大小（m）
   */
  @Input() maxSize = 100;
  /**
   * 单张最大
   */
  @Input() singleSize = 10;
  /**
   * 图片宽度
   */
  @Input() width = 200;
  /**
   * 图片格式
   * - 数组类型
   * - 比如`['image/jpeg']`
   */
  @Input() exceptImage = ['image/jpeg', 'image/jpg', 'image/png'];
  /**
   * 成功的回调
   */
  // tslint:disable-next-line: no-output-native
  @Output() success: EventEmitter<any> = new EventEmitter<any>();
  /**
   * 失败的回调
   */
  @Output() fail: EventEmitter<any> = new EventEmitter<any>();
  /**
   * 删除的回调
   */
  @Output() remove: EventEmitter<any> = new EventEmitter<any>();
  /**
   * 上传图片的列表
   */
  @Input() imgList: Array<any> = [];

  @Input() scene: string;

  constructor(private http: _HttpClient, private message: NzMessageService) {}

  // 上传中
  loadingList: Array<any> = [];
  // 上传失败
  errorList: Array<any> = [];

  // 提示文字
  allowTypeText = '';
  // 临时图片对象
  imageInfo: {
    url: '';
  };

  // 弹窗部分
  isVisibleMiddle = false;
  actIndex = 1;

  ngOnInit() {
    this.editable = this.editable === true ? true : false;
    this.uploadImage = this.uploadImage || URLS.uploadImage.url || '';
    this.maxCount = this.maxCount || 9;
    this.maxSize = this.maxSize || 100;
    this.singleSize = this.singleSize || 10;
    this.width = this.width || 200;
    this.allowTypeText = this.imageArr2String(this.exceptImage);
  }

  // 增加图片
  addImage(targetList: Array<any>, imageInfo: object): void {
    const deepTarget = JSON.parse(JSON.stringify(imageInfo));
    if (targetList) {
      targetList.push(deepTarget);
    }
  }
  // 删除图片
  removeImage(targetList: Array<any>, index: number): void {
    if (targetList) {
      targetList.splice(index, 1);
      // this.message.create('success', `删除成功`);
      // 只有当删除已经上传成功的图片，才向父组件回传索引
      if (targetList === this.imgList) {
        this.remove.emit(index);
      }
    }
  }
  // 清空列表
  emptyList(targetList: Array<any>) {
    if (targetList) {
      targetList.length = 0;
    }
  }

  // 定制http请求
  thumbCustomReq = (item: UploadXHRArgs) => {
    const file = item.file;
    const { size, name } = file;

    const formData = new FormData();
    formData.append('file', file as any);

    // 发送请求之前，上传列表中增加一张图片
    this.imageInfo = {
      ...this.imageInfo,
      ...{
        name,
        size,
      },
    };

    this.addImage(this.loadingList, this.imageInfo);

    return this.http
      .post(item.action!, formData)
      .pipe(timeout(60000))
      .subscribe(
        event => {
          if (event && event.status === 0 && event.data) {
            if (event.data.statusCode === 'Success') {
              this.success.emit(event.data);
              // this.message.create('success', `图片上传成功`);
            }
          } else {
            this.fail.emit(event.data);
            this.addImage(this.errorList, this.imageInfo);
            this.message.create('error', event.errorMsg);
          }
          // 清空上传中的列表
          this.emptyList(this.loadingList);
        },
        err => {
          this.emptyList(this.loadingList);
          this.addImage(this.errorList, this.imageInfo);
        },
      );
  };
  // 上传之前的钩子
  thumbBeforeUpload = (file: UploadFile): boolean => {
    const { type, size } = file;
    // 图片类型限制
    const expectType = this.validateImageType(type, this.exceptImage);
    const typeTips = this.imageArr2String(this.exceptImage);
    // 单个图片大小限制
    const islimit = this.validateImageSize(size, this.singleSize);

    // 总大小限制
    const allSize = this.getAllmagesSize() + this.byte2m(size);
    const overSize = this.validateAllImagesSize(allSize, this.maxSize);

    if (!expectType) {
      this.message.create('error', `只允许上传${typeTips}格式的图片`);
      return false;
    }

    if (islimit) {
      this.message.create('error', `图片大小不能超过${this.maxSize}m`);
      return false;
    }

    if (overSize) {
      this.message.create('error', `图片总大小不能超过${this.maxSize}m`);
      return false;
    }

    return true;
  };

  // 显示弹窗
  showDialog(index) {
    this.changFocusImg(index);
    this.isVisibleMiddle = true;
  }
  // 切换图片
  changFocusImg(index) {
    this.actIndex = index;
  }
  // 上一张
  prevFocusImg() {
    this.actIndex = --this.actIndex < 0 ? this.imgList.length - 1 : this.actIndex--;
  }
  // 下一张
  nextFocusImg() {
    this.actIndex = ++this.actIndex >= this.imgList.length ? 0 : this.actIndex++;
  }

  // 图片地址校验后，更新
  updateUrl(imgUrl, item) {
    item.url = imgUrl;
  }

  // ===== Helper
  // 图片转换
  private imageArr2String(arr: Array<any>) {
    let temp = '';
    let len = arr.length;
    arr.forEach((v, i) => {
      temp += v.split('/')[1];
      if (i !== len - 1) {
        temp += ',';
      }
    });
    return temp;
  }
  // 单位转换
  private byte2m(value: number) {
    return value / (1024 * 1024);
  }
  // 验证图片类型是否合法
  private validateImageType(expect: string, target: string | Array<string>) {
    const temp = typeof target === 'string' ? [target] : target;
    return temp.some(it => {
      return expect === it;
    });
  }

  // 验证图片大小是否合法
  private validateImageSize(expect: number, target: number) {
    return this.byte2m(expect) > target;
  }
  // 验证图片总大小是否合法
  private validateAllImagesSize(expect: number, target: number) {
    return expect > target;
  }

  // 获取已经上传的图片总大小
  private getAllmagesSize() {
    let result = 0;
    this.imgList.map(it => {
      if (it.size > 0) {
        result += it.size;
      }
    });
    return this.byte2m(result);
  }
}
